import { Typography } from 'antd'

import { RefundTableCell } from '../table.common'

const { Text } = Typography

export const CellTotalPayment: RefundTableCell<number> = (value) => (
	<Text>{new Intl.NumberFormat().format(value)}</Text>
)
